import { useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEraser } from "@fortawesome/free-solid-svg-icons";

import { getAbogados } from "../../../../../redux/Sections/Abogados/actions";
import { showTable } from "../../../../../redux/Sections/Inmuebles/actions";
import { grupoEtapasService } from "../../../../../_services/grupoEtapas.service";
import { tipoEtapasService } from "../../../../../_services/tipoEtapas.service";
import { setLoading } from "../../../../../redux/Loading/actions";
import { emptyOption } from "../../../../../constants";
import { useUser } from "../../../../../hooks/useUser";
import Select from "../../../../../components/Select";

export const MisContribuyentesFilter = ({ action, reference, showFilter, setShowFilter, setShowTable, setFilters }) => {
  const dispatch = useDispatch();
  const user = useUser();

  const [grupos, setGrupos] = useState([]);
  const [tipos, setTipos] = useState([]);
  const [grupo, setGrupo] = useState("");
  const [tipo, setTipo] = useState("");

  const {
    register,
    handleSubmit,
    control,
    reset
  } = useForm({});

  const [tags, setTags] = useState({});

  useEffect(() => {
    const getData = () => {
      dispatch(getAbogados());
    };

    getData();
  }, []);

  useEffect(() => {
    const getData = async () => {
      let response = await grupoEtapasService.getGrupoEtapas();

      if (response?.length) {
        setGrupos(response.map(e => {
          return {
            ...e,
            value: e.id,
            label: e.nombre
          };
        }));
      }

    };

    getData();
  }, []);

  useEffect(() => {
    const getData = async () => {
      if (grupo && grupo.id) {
        dispatch(setLoading(true));

        let response = await tipoEtapasService.getTipoEtapas(grupo.id);

        if (response?.length) {
          setTipos(response.map(e => {
            return {
              ...e,
              value: e.tipo,
              label: e.nombre
            };
          }));

          dispatch(setLoading(false));
        }
        else {
          dispatch(setLoading(false));
        }
      }
      else {
        setTipos([]);
      }
    };

    getData();
  }, [grupo]);

  const handleClean = () => {
    reset({});
    setTags({});
    setGrupo({});
    setTipo({});
  };

  const onSubmit = async (data) => {
    setTags(data);
    setFilters(data);

    if("A00" !== user?.abogado){
      data.usuario = user.dni;
    }

    dispatch(action(data));

    setShowFilter(false);
    if (setShowTable) {
      setShowTable(true);
    }
    dispatch(showTable());
  };

  const handleChange = (e) => {
    if (e) {
      setTipo("");
      setGrupo(e);
    }
    else {
      setGrupo("");
    }
  };

  return (
    <div className="filter-container" >
      {showFilter ? (
        <Form onSubmit={handleSubmit(onSubmit)} >
          <Row>
            <Col sm={12} md={4} className="mt-3">
              <Form.Label className="mb-2">Contribuyente</Form.Label>
              <Form.Control
                name="apynom"
                {...register("apynom")}
              />
            </Col>
            <Col sm={12} md={4} className="mt-3">
              <Form.Label className="mb-2">N° imponible</Form.Label>
              <Form.Control
                name="inmueble"
                {...register("inmueble")}
              />
            </Col>
          </Row>
          <Row>
            <Col sm={12} md={4} className="mt-3">
              <Form.Label className="mb-2">Estado</Form.Label>
              <Controller
                name="gp_estado"
                control={control}
                render={({ field: { onChange } }) => {
                  return (
                    <Select
                      options={grupos?.length ? [emptyOption, ...grupos] : [emptyOption]}
                      value={grupo}
                      onChange={(e) => {
                        handleChange(e);
                        return onChange(e?.value);
                      }}
                    />
                  );
                }}
              />
            </Col>
            {grupo?.value ? (
              <Col sm={12} md={4} className="mt-3">
                <Form.Label style={{ margin: 11.5 }}></Form.Label>
                <Controller
                  name="estado"
                  control={control}
                  render={({ field: { onChange } }) => {
                    return (
                      <Select
                        options={tipos?.length ? [emptyOption, ...tipos] : [emptyOption]}
                        value={tipo}
                        onChange={(e) => {
                          setTipo(e);
                          return onChange(e?.value);
                        }}
                      />
                    );
                  }}
                />
                <input
                  className="input-required"
                  onChange={() => ""}
                  value={tipo ? tipo : ""}
                  required
                />
              </Col>
            ) : ""}
          </Row>
          <Row>
            <Col sm={12} md={4} className="mt-3">
              <Form.Label className="mb-2">Barrio</Form.Label>
              <Form.Control
                name="barrio"
                {...register("barrio")}
              />
            </Col>
            <Col sm={12} md={4} className="mt-3">
              <Form.Label className="mb-2">Calle</Form.Label>
              <Form.Control
                name="calle"
                {...register("calle")}
              />
            </Col>
            <Col sm={12} md={4} className="mt-3">
              <Form.Label className="mb-2">Altura</Form.Label>
              <Form.Control
                name="nro"
                {...register("nro")}
              />
            </Col>
          </Row>

          <Row>
            <Col sm={12} md={4} className="mt-3">
              <Form.Label className="mb-2">DNI</Form.Label>
              <Form.Control
                name="dni"
                {...register("dni")}
              />
            </Col>
            <Col sm={12} md={4} className="mt-3">
              <Form.Label className="mb-2">CUIM</Form.Label>
              <Form.Control
                name="cuim"
                {...register("cuim")}
              />
            </Col>
            <Col sm={12} md={4} className="mt-3">
              <Form.Label className="mb-2">CUIT</Form.Label>
              <Form.Control
                name="cuit"
                {...register("cuit")}
              />
            </Col>
          </Row>

          <Row className=" d-flex justify-content-end" >
            <Col style={{ maxWidth: 122 }}>
              <Button
                type="button"
                variant="danger"
                onClick={handleClean}
                className="danger-button d-flex align-items-center"
              >
                <FontAwesomeIcon icon={faEraser} size="1x" /><span className="ml-2">LIMPIAR</span>
              </Button>
            </Col>
            <Col style={{ maxWidth: 122 }}>
              <Button
                type="submit"
                ref={reference}
                className="custom-button"
              >
                BUSCAR
              </Button>
            </Col>
          </Row>
        </Form>
      ) : null}
      <>
        {
          <Row className="d-flex justify-content-start mt-4" style={{ paddingLeft: 15 }}>
            <div className="filterby">
              <h5 style={{ marginTop: "2px", fontWeight: 700 }} >Filtrado por:</h5>
            </div>
            {!Object.values(tags).filter((e) => e !== "").length && (
              <div className="tags">
                <span
                  key="sinopciones"
                >
                  No hay opciones seleccionadas
                </span>
              </div>
            )}

            {tags?.apynom &&
              <div className="tags">
                <span key="apynom" >
                  Nombre : {tags.apynom}
                </span>
              </div>}

            {tags?.inmueble &&
              <div className="tags">
                <span key="inmueble" >
                  Número Imponible : {tags.inmueble}
                </span>
              </div>}

            {tags.estado &&
              <div className="tags">
                <span key="partidaInmobiliaria" >
                  Grupo : {grupo?.nombre}
                </span>
              </div>}

            {tags.estado &&
              <div className="tags">
                <span key="estado" >
                  Estado : {tipo?.nombre}
                </span>
              </div>}

            {tags.domicilio &&
              <div className="tags">
                <span key="domicilio" >
                  Domicilio : {tags.domicilio}
                </span>
              </div>}

            {tags.barrio &&
              <div className="tags">
                <span key="barrio" >
                  Barrio : {tags.barrio}
                </span>
              </div>}

            {tags.recurso &&
              <div className="tags">
                <span key="recurso" >
                  Recurso : {tags.recurso}
                </span>
              </div>}

            {tags.abogado &&
              <div className="tags">
                <span key="abogado" >
                  Abogado : {tags.abogado}
                </span>
              </div>}

            {tags.calle &&
              <div className="tags">
                <span key="calle" >
                  Calle: {tags.calle}
                </span>
              </div>}

            {tags.nro &&
              <div className="tags">
                <span key="nro" >
                  Altura : {tags.nro}
                </span>
              </div>}

            {tags?.dni && (
              <div className="tags">
                <span color="green" key="dni">
                  DNI : {tags?.dni}
                </span>
              </div>
            )}

            {tags?.cuim && (
              <div className="tags">
                <span color="green" key="cuim">
                  CUIM : {tags?.cuim}
                </span>
              </div>
            )}

            {tags?.cuit && (
              <div className="tags">
                <span color="green" key="cuit">
                  CUIT : {tags?.cuit}
                </span>
              </div>
            )}
          </Row>
        }
      </>
    </div>
  );
};
